import { Tooltip } from 'antd'
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { useTranslation } from 'react-i18next'
import Button, { ButtonProps } from '../../../antd/button'

interface Props extends ButtonProps {

}

const SeenBtn: React.FC<Props> = (props) => {
    const { t } = useTranslation()

    return (
        <Tooltip title={t('mark_as_read')}>
            <Button
                style={{ background:"#176c1790"}}
                type='primary'
                shape='circle'
                icon={<IoCheckmarkDoneSharp />}
                {...props}
            />
        </Tooltip>
    )
}

export default SeenBtn
